module.exports = __webpack_public_path__ + "static/media/clase.87c3c2d7.svg";